import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { PhoneValidationRequest, PhoneValidationResponse } from "../models/PhoneValidation";

@Injectable({
    providedIn: 'root'
})
export class PhoneValidationService {
    constructor(private http: HttpClient) { }

    validatePhoneNumber(phoneNumber: string): Observable<PhoneValidationResponse> {
        const request: PhoneValidationRequest = { phoneNumber };
        return this.http.post<PhoneValidationResponse>('api/phonevalidation/validate', request)
            .pipe(
                catchError(error => {
                    console.error('Phone validation error:', error);
                    return of({
                        isValid: true,
                        isMobile: true,
                        isLandline: false,
                        isOther: false,
                        isTollFree: false,
                        numberType: null,
                        errorMessage: 'Validation unavailable'
                    });
                })
            );
    }
}
